import { List } from '@coconut-software/ui';
import { Map, Globe } from '@coconut-software/ui/dist/icons';
import React from 'react';
import { useIntl } from 'react-intl';

type Region = {
  id: string;
  name: string;
  country?: boolean;
  country_name?: string;
};

interface RegionListItemProps {
  regions: Region[];
  selectRegion: (region: Region) => void;
  setSearching: (searching: boolean) => void;
}

const RegionListItem: React.FC<RegionListItemProps> = ({
  regions,
  selectRegion,
  setSearching,
}) => {
  const intl = useIntl();

  const onClick = (targetRegion: Region) => {
    setSearching(false);
    selectRegion(targetRegion);
  };

  const hasNestedRegions = regions.length > 1;

  return (
    <List.Item
      aria-label={intl.formatMessage(
        { id: 'Navigation.aria_label.card' },
        { navItem: regions[0].country_name },
      )}
      onClick={!hasNestedRegions ? () => onClick(regions[0]) : undefined}
      primary={regions[0].country_name}
      startAdornment={<Globe />}
    >
      {hasNestedRegions ? (
        <List dense nested={1}>
          {regions.map((subRegion) => (
            <List.Item
              aria-label={intl.formatMessage(
                { id: 'Navigation.aria_label.card' },
                { navItem: subRegion.country_name },
              )}
              key={subRegion.id}
              onClick={() => onClick(subRegion)}
              primary={
                subRegion.country
                  ? `${subRegion.name} (${intl.formatMessage({
                      id: 'Navigation.aria_label.virtual',
                    })})`
                  : subRegion.name
              }
              startAdornment={<Map />}
            />
          ))}
        </List>
      ) : undefined}
    </List.Item>
  );
};

export default RegionListItem;
